<template>
        <div class="position-stablez">
            <div class="program-name-header">
                <shopify-program-name @updateProgram="$emit('updateProgram')" :current_program="current_program"/>
            </div>
       
            <div class="row mt-3 mr-2 ml-0">
   
                <div class="rec">
                    <div class="scroll-view">
                    <draggable :class="{'pointer': edit_module_chart}" v-model="current_program.modules" @change="updateProgram" :options="{disabled: !edit_module_chart}">
                    <div class="margin-left-right-8" v-for="(module_,index) in current_program.modules" :key="index">
                        <a class="pointer" @click="openModuleCart(module_)">
                         <div class="respiratory-diseases" :class="{ 'edit-length':edit_module_chart }" :style="{ color: customColor(module_) }" >
                             
                                <span class="inside-module-cart-text">{{module_.name.EN}}</span>
                                <span class="duration-inside-text">{{ secondsToHms(module_.duration, true) }}</span>
                            
                        </div> 
                        </a>
                        <div v-if="edit_module_chart" class="float-right margin-30">
                            <!-- <img class="mr-2" id="" src="../../assets/images/u10.svg"
                                        />  -->
                            <!-- <a class="pointer" @click="openModal(module_,index)"> <img id="" class="mt-n2" src="../../assets/images/u7.svg"
                                        /> </a> -->
                                <div class="x-button-holder">
                                     <a class="pointer" @click="openModal(module_,index)">
                                         <img  height="30" width="22" src="../../assets/images/delete-cancel-icon.svg" 
				            					class="x-button"  
				            					/>
                                    </a> 

                                </div>
                                        
                        </div>
                    </div>

                    </draggable>
                    </div>
                    <div class="total-duration-footer">
                        <div class="duration-holder">
                            <p>
                                <span class="total-duration-text"> Total Duration: </span>
                                <span class="total-duration-text total-duration-inside-text">{{totalDurationCalc}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <shopify-checkout-button @goToCheckout="goToCheckout"
            :show_save_button="true"
            @saveModuleGoDraftsPage="saveModuleGoDraftsPage"
            :fullWidth="false"
            />

            <div v-if="current_program.in_class == 1">
                <br>
                <p class="in-class-warning"> IN-CLASS: You have added an In-Class Module.</p>
                <p class="in-class-warning"> This will create an In-Class Program that will not be available for remote completion via the Caregiver app.</p>
            </div>

            <div v-if="remove_modal">
                  <remove-module-dialog :remove_modal="remove_modal"  
                  :modalToRemove="modalToRemove"
                  :ok_title="'Remove'"
                 @removeModuleFromChart="removeModuleFromChart"
                 @closeModal="closeModal"
                 :modal_view="false"></remove-module-dialog>
              
             </div>
    </div>
  
    
</template>
<script>
import MixinSME from '../sme/MixinSME';
import RemoveModuleDialog from './RemoveModuleDialog'
import ShopifyProgramName from './ShopifyProgramName'
import ShopifyCheckoutButton from './ShopifyCheckoutButton'

export default{
    mixins: [MixinSME],
    components: {
        RemoveModuleDialog,
        ShopifyProgramName,
        ShopifyCheckoutButton
    },
    props:['current_program','module_list'],
    data() {
        return{
          edit_module_chart:true,
          remove_modal:false,
          program_name:'',
          modalToRemove:{
              index:'',
              module:''
          }
        }
    },
    computed:{
        totalDurationCalc: function (){
            let total = 0
            this.current_program.modules.forEach(elem => total += elem.duration)
            return this.secondsToHms(total,true);
        },
    },
    methods : {
        customColor(module) {
          return module.custom ? '#11A5A7' : 'black';
        },
        openModal: function(val,index){
            if(val){
                this.modalToRemove.module = val
                this.modalToRemove.index = index
            }
            this.remove_modal = true
        },
        openModuleCart: function(module){
            this.$emit('openModuleFromcart', module)

        },
        moduleDrag:function(){
            console.log("drag")
        },
        removeModuleFromChart: function(mod, module_view){
            this.closeModal();
            this.$emit('removeModuleFromChart', mod, module_view)
        },
        saveModuleGoDraftsPage: function(){
            this.$router.push({ name : 'shopify.dashboard', params:{ id: this.current_program.id} })
        },
        goToCheckout: function(){
            this.$router.push({ name: 'shopify.checkout', params: { program: this.current_program.id }})
        },
        closeModal: function(){
            this.remove_modal = false
            this.modalToRemove = {}
        },
        updateProgram: function(a){
            if(a.moved){
                var element = a.moved.element;
                var new_index = a.moved.newIndex;
                var old_index = a.moved.oldIndex;

                var params = {
                    id : this.current_program.id,
                    module_id : element.id,
                    filters : {
                        new_index : new_index,
                        old_index : old_index
                    }
                }

                this.$store.dispatch('changeModuleOrder', params).then((res) => {
                
                }).catch((error) => {
                    console.log(error);
                });

            }
			
        }
    }
}
</script>
<style scoped>

.in-class-warning {
    color: #11A5A7;
    font-weight: bold;
}

.scroll-view{
    overflow: scroll !important;
    overflow-x: hidden !important;
    height: 91%;
    padding-bottom: 8px !important;
}
.x-button-holder{
    margin-right: 4px;
    max-width: 25px;
    max-height: 25px;
}
.x-button{
    margin-top: -8px;
    min-width: 35px;
    min-height: 40px;
    margin-left: auto;
    margin-right: auto;
}
.lesson-input{
	width: 81%;
	height: 100%;
	background-color: #EDEDED !important;
	border: none !important;
	border-radius:3px;
}
.no-border{
    border-top: none;
    border-left: none;
    border-right: none;
}
.margin-left-right-8{
    margin: 0 8px;
}
.margin-30{
    margin-top: -40px
}
.duration-inside-text{
    position: absolute;
    right: 8px;
    top: 10px;
    font-weight: 400;
}
.total-duration-inside-text{
    right:20px;
}
.inside-module-cart-text{
    font-family: Gilroy, sans-serif;
    font-kerning: normal;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    top: 10px;
    left: 8px;
    position: absolute;
    max-width: 74%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.line-vertical{
  width: 95%;
  height: 1px;
  border: 1px solid #d7d7d7;
  background-color: #ffffff;
  box-sizing: border-box;
  font-family: 'Arial Regular', 'Arial', sans-serif;
  color: #333333;
  text-align: center;
  line-height: normal;
}
.duration-holder{
    position: absolute;
    top: -1vh;
    height: 5.3vh;
    background-color: rgba(128, 128, 128, 0.1450980392156863);
    border-radius: 8px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    align-self: center;
    padding: 0px 8px 0px 8px;
    box-sizing: border-box;
    width: 100%;
    text-align:left;
    padding-top: 1vh;
}
.total-duration-footer{
    /* position:relative; */
    /* background-color: rgba(128, 128, 128, 0.1450980392156863); */
    position: relative;
    /* bottom: 9px; */
    /*left: 0px;
    right: 0px; */
    /* width: 100%;
    border-radius: 8px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px; */
}
@media only screen and (max-width:900px){
    .total-duration-footer{
        position: relative;
        width: auto;
         bottom: -10px;
    }
}
.total-duration-text{
    position: absolute;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 3vh;
    text-align: left;
    color: #333333;
}
.pointer{
    cursor:pointer;
}
.build-program-title{
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    color: #11A5A7;
}
.program-name-header{
    /* width: max-content; */
    width: 92%;
    border-width: 0px;
    /* display: flex; */
    font-family: 'Gilroy Bold', 'Gilroy Regular', 'Gilroy', sans-serif;
    font-feature-settings: 'kern';
    font-kerning: normal;
    font-weight: 700;
    font-style: normal;
    font-size: 24px;

}
.your-modules{
    max-width: 90%;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    font-kerning: normal;
}
.edit-icon{
    left: 0px;
    top: 0px;
    width: 19px;
    height: 19px;
    display: flex;
}
.rec{
    position:relative; 
    padding: 10px 0px 0px 0px;
    margin-top: 0px;
    width: 95%;
    min-height: 50vh;
    max-height: 50vh !important;
    border-radius: 8px;
    background-color: rgba(128, 128, 128, 0.15);
    box-sizing: border-box;
    font-family: 'Gilroy', sans-serif;
    color: #7f7f7f;
    text-align: center;
    line-height: normal;
}
.respiratory-diseases {
    /* margin-left: 6px !important; */
  margin-bottom: 8px;
  position:relative;
  width: 100%;
  height: 38px;
  border-radius: 8px;
  background-color: #ffffff;
  box-sizing: border-box;
  font-family: 'Gilroy', sans-serif;
  color: #333333;
  text-align: left;
  line-height: normal;
  /* display: grid; */
}
.edit-length{
    width: 92% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/shopify/ShopifyCart.vue